import { withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, Transition as _Transition, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../public/icons/explorer/global.svg'
import _imports_1 from '../../../../public/icons/explorer/star.svg'
import _imports_2 from '../../../../public/icons/explorer/star-empty.svg'
import _imports_3 from '../../../../public/icons/explorer/context_menu/ellipses.svg'
import _imports_4 from '../../../../public/icons/explorer/context_menu/open.svg'
import _imports_5 from '../../../../public/icons/workflow/run.svg'
import _imports_6 from '../../../../public/icons/data/add.svg'
import _imports_7 from '../../../../public/icons/explorer/context_menu/new_folder.svg'
import _imports_8 from '../../../../public/icons/explorer/context_menu/new_process.svg'
import _imports_9 from '../../../../public/icons/explorer/context_menu/new_reportbook.svg'
import _imports_10 from '../../../../public/icons/explorer/power_bi.svg'
import _imports_11 from '../../../../public/icons/explorer/context_menu/new_word.svg'
import _imports_12 from '../../../../public/icons/explorer/context_menu/new_ppt.svg'
import _imports_13 from '../../../../public/icons/explorer/context_menu/new_xl3.svg'
import _imports_14 from '../../../../public/icons/explorer/context_menu/new_calcscript.svg'
import _imports_15 from '../../../../public/icons/explorer/context_menu/new_generic.svg'
import _imports_16 from '../../../../public/icons/explorer/context_menu/cut.svg'
import _imports_17 from '../../../../public/icons/explorer/context_menu/copy.svg'
import _imports_18 from '../../../../public/icons/explorer/context_menu/paste.svg'
import _imports_19 from '../../../../public/icons/explorer/context_menu/edit.svg'
import _imports_20 from '../../../../public/icons/explorer/context_menu/rename.svg'
import _imports_21 from '../../../../public/icons/explorer/context_menu/delete.svg'
import _imports_22 from '../../../../public/icons/explorer/context_menu/export.svg'
import _imports_23 from '../../../../public/icons/explorer/context_menu/export_as.svg'
import _imports_24 from '../../../../public/icons/explorer/context_menu/pdf.svg'
import _imports_25 from '../../../../public/icons/explorer/context_menu/excel.svg'
import _imports_26 from '../../../../public/icons/explorer/context_menu/ppt.svg'
import _imports_27 from '../../../../public/icons/explorer/context_menu/import.svg'
import _imports_28 from '../../../../public/icons/users/roles.svg'
import _imports_29 from '../../../../public/icons/explorer/context_menu/refresh.svg'
import _imports_30 from '../../../../public/icons/info.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-5a3dc31b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"position":"relative","top":"0.06rem","left":"-17px"},
  src: _imports_0,
  class: "global-icon-color"
}
const _hoisted_2 = {
  key: 1,
  style: {"position":"relative","top":"19px","left":"-6px","height":"8px","width":"8px","border-radius":"100%","background":"var(--background-striped)","display":"inline-block"}
}
const _hoisted_3 = { class: "name" }
const _hoisted_4 = ["title"]
const _hoisted_5 = {
  key: 1,
  class: "alm-badge"
}
const _hoisted_6 = {
  key: 2,
  class: "name"
}
const _hoisted_7 = {
  key: 3,
  class: "name"
}
const _hoisted_8 = {
  key: 4,
  class: "name"
}
const _hoisted_9 = {
  key: 0,
  class: "children"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "theme-svg",
  src: _imports_4
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "theme-svg",
  src: _imports_4
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "theme-svg",
  src: _imports_4
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "theme-svg",
  src: _imports_4
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "theme-svg",
  src: _imports_5
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "theme-svg",
  src: _imports_6
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "theme-svg",
  src: _imports_7
}, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "theme-svg",
  src: _imports_8
}, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "theme-svg",
  src: _imports_9
}, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "theme-svg",
  src: _imports_10
}, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "theme-svg",
  src: _imports_11
}, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "theme-svg",
  src: _imports_12
}, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "theme-svg",
  src: _imports_13
}, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "theme-svg",
  src: _imports_14
}, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "theme-svg",
  src: _imports_15
}, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "theme-svg",
  src: _imports_16
}, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "theme-svg",
  src: _imports_17
}, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "theme-svg",
  src: _imports_18
}, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "theme-svg",
  src: _imports_19
}, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "theme-svg",
  src: _imports_20
}, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "theme-svg",
  src: _imports_21
}, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "theme-svg",
  src: _imports_22
}, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "theme-svg",
  src: _imports_23
}, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "theme-svg",
  src: _imports_24
}, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "theme-svg",
  src: _imports_25
}, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "theme-svg",
  src: _imports_26
}, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "theme-svg",
  src: _imports_27
}, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "theme-svg",
  src: _imports_28
}, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "theme-svg",
  src: _imports_28
}, null, -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "theme-svg",
  src: _imports_29
}, null, -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "icon",
    src: _imports_30,
    style: {"width":"50px","height":"50px"}
  })
], -1))
const _hoisted_45 = { style: {"padding-top":"15px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FileSystemObjectIcon = _resolveComponent("FileSystemObjectIcon")!
  const _component_FileSystemObject = _resolveComponent("FileSystemObject", true)!
  const _component_ContextMenuButton = _resolveComponent("ContextMenuButton")!
  const _component_ContextMenu = _resolveComponent("ContextMenu")!
  const _component_CommonButton = _resolveComponent("CommonButton")!
  const _component_Confirm = _resolveComponent("Confirm")!

  return (_ctx.UserCanView)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref: "fso",
        class: _normalizeClass(["fso", {disabled: _ctx.IsThisFolderDisabled, 'is-global': _ctx.IsGlobal}])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass([{
        selected:_ctx.IsSelected,
        cutcopySelected: _ctx.IsCutCopySelected,
        hover: true ,
        detailed:_ctx.HideExpander==true,
        detailed_v2: _ctx.HideExpander==true,
      }, "fso-main"]),
          onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.Fso_Click && _ctx.Fso_Click(...args)), ["stop"])),
          onDblclick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.Fso_Dblclick())),
          onContextmenu: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.Fso_ContextMenu && _ctx.Fso_ContextMenu(...args)), ["prevent","stop"]))
        }, [
          (_ctx.Fso.objectType==_ctx.FileSystemType.Folder && _ctx.HideExpander!=true)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["expander", {expanded:_ctx.IsExpanded, collapsed:!_ctx.IsExpanded, fschidden:!_ctx.HasChildren}]),
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.Expander_Click && _ctx.Expander_Click(...args)), ["stop"]))
              }, null, 2))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createVNode(_component_FileSystemObjectIcon, { Fso: _ctx.Fso }, null, 8, ["Fso"]),
            (_ctx.IsGlobal && _ctx.Fso.objectType==_ctx.FileSystemType.Folder)
              ? (_openBlock(), _createElementBlock("img", _hoisted_1))
              : _createCommentVNode("", true),
            (_ctx.IsGlobal && _ctx.Fso.objectType!=_ctx.FileSystemType.Folder)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("img", {
                    src: _imports_0,
                    style: {"position":"relative","top":"-11.5px","right":"1px"},
                    class: _normalizeClass({'accent-svg':!_ctx.IsSelected})
                  }, null, 2)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("span", _hoisted_3, [
            _createElementVNode("span", {
              class: _normalizeClass({
            nameInner:true,
            searchResult: _ctx.IsSearchResult,
            currentSearchResult: _ctx.IsCurrentSearchResult
          }),
              title: _ctx.Fso.name
            }, _toDisplayString(_ctx.Fso.name), 11, _hoisted_4)
          ]),
          (_ctx.isAlm && !_ctx.Secondary && _ctx.almBadgeCount(_ctx.Fso) !== 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.almBadgeCount(_ctx.Fso)), 1))
            : _createCommentVNode("", true),
          (_ctx.HideExpander==true)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.FormatType(_ctx.Fso.objectType)), 1))
            : _createCommentVNode("", true),
          (_ctx.HideExpander==true)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.FormatDate(_ctx.Fso.lastModified)), 1))
            : _createCommentVNode("", true),
          (_ctx.HideExpander==true)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.FormatLastModifiedBy(_ctx.Fso.lastModifiedBy)), 1))
            : _createCommentVNode("", true),
          ((_ctx.Fso.objectType!=_ctx.FileSystemType.Folder || _ctx.HideExpander) && _ctx.IsFavorite && !_ctx.isAlm)
            ? (_openBlock(), _createElementBlock("img", {
                key: 5,
                class: "icon",
                src: _imports_1,
                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.ToggleFavorite && _ctx.ToggleFavorite(...args)), ["stop","prevent"]))
              }))
            : _createCommentVNode("", true),
          ((_ctx.Fso.objectType!=_ctx.FileSystemType.Folder || _ctx.HideExpander) && !_ctx.IsFavorite && !_ctx.isAlm)
            ? (_openBlock(), _createElementBlock("img", {
                key: 6,
                class: "icon theme-svg",
                src: _imports_2,
                onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.ToggleFavorite && _ctx.ToggleFavorite(...args)), ["stop","prevent"]))
              }))
            : _createCommentVNode("", true),
          (!_ctx.IsThisFolderDisabled && _ctx.Fso.id!=0.1 && !_ctx.isAlm)
            ? (_openBlock(), _createElementBlock("img", {
                key: 7,
                class: "icon theme-svg",
                src: _imports_3,
                onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.Fso_ContextMenu && _ctx.Fso_ContextMenu(...args)), ["prevent","stop"]))
              }))
            : _createCommentVNode("", true)
        ], 34),
        _createVNode(_Transition, { name: "fso-expanded" }, {
          default: _withCtx(() => [
            (_ctx.IsExpanded && _ctx.HideExpander!=true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_TransitionGroup, {
                    name: "fso-expanded",
                    tag: "span"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.FolderChildren, (child) => {
                        return (_openBlock(), _createBlock(_component_FileSystemObject, {
                          isAlm: _ctx.isAlm,
                          key: child.id,
                          Fso: child,
                          CanUserExpand: true,
                          CanUserSelect: _ctx.CanUserSelect,
                          ChangeUrlOnSelect: _ctx.ChangeUrlOnSelect,
                          CanUserOpenWithDoubleClick: _ctx.CanUserOpenWithDoubleClick,
                          IsParentFolderDisabled: _ctx.IsThisFolderDisabled,
                          Secondary: _ctx.Secondary
                        }, null, 8, ["isAlm", "Fso", "CanUserSelect", "ChangeUrlOnSelect", "CanUserOpenWithDoubleClick", "IsParentFolderDisabled", "Secondary"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_ctx.CanShowContextMenu && _ctx.ShowContextMenu)
          ? (_openBlock(), _createBlock(_component_ContextMenu, {
              key: 0,
              TriggerEvent: _ctx.ContextMenuEvent,
              onClose: _cache[35] || (_cache[35] = ($event: any) => (_ctx.ContextMenuEvent=null))
            }, {
              buttons: _withCtx(() => [
                (_ctx.Fso.objectType!=_ctx.FileSystemType.Folder &&
            _ctx.Fso.objectType!=_ctx.FileSystemType.ReportBook &&
            _ctx.Fso.objectType!=_ctx.FileSystemType.CalcScript)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["context_menu_btn", {disabled: !_ctx.Can_Open}]),
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.Fso_Open()))
                    }, [
                      _hoisted_10,
                      _createTextVNode("  " + _toDisplayString(_ctx.Localizer.Localize("FileSystemObject_Open")), 1)
                    ], 2))
                  : _createCommentVNode("", true),
                (_ctx.Fso.objectType==_ctx.FileSystemType.XL3)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(["context_menu_btn", {disabled: !_ctx.Can_OpenInExcel}]),
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.Fso_OpenInExcel()))
                    }, [
                      _hoisted_11,
                      _createTextVNode("  " + _toDisplayString(_ctx.Localizer.Localize("FileSystemObject_Open_in_Excel")), 1)
                    ], 2))
                  : _createCommentVNode("", true),
                (_ctx.Fso.objectType==_ctx.FileSystemType.XL3 || _ctx.Fso.objectType==_ctx.FileSystemType.PowerBI)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: _normalizeClass(["context_menu_btn", {disabled: !_ctx.Can_OpenInPopup}]),
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.Fso_OpenInPopup()))
                    }, [
                      _hoisted_12,
                      _createTextVNode("  Open in Popup ")
                    ], 2))
                  : _createCommentVNode("", true),
                (_ctx.Fso.objectType==_ctx.FileSystemType.XL3)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 3,
                      class: _normalizeClass(["context_menu_btn", {disabled: !_ctx.Can_OpenInTab}]),
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.Fso_OpenNewTab()))
                    }, [
                      _hoisted_13,
                      _createTextVNode("  " + _toDisplayString(_ctx.Localizer.Localize("FileSystemObject_Open_Newtab")), 1)
                    ], 2))
                  : _createCommentVNode("", true),
                (_ctx.Fso.objectType===_ctx.FileSystemType.ReportBook || _ctx.Fso.objectType===_ctx.FileSystemType.CalcScript)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 4,
                      class: _normalizeClass(["context_menu_btn", {disabled: !_ctx.Can_Run}]),
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.Fso_Run()))
                    }, [
                      _hoisted_14,
                      _createTextVNode("  " + _toDisplayString(_ctx.Localizer.Localize("FileSystemObject_Run")), 1)
                    ], 2))
                  : _createCommentVNode("", true),
                (_ctx.Fso.objectType===_ctx.FileSystemType.Folder)
                  ? (_openBlock(), _createBlock(_component_ContextMenuButton, {
                      key: 5,
                      title: _ctx.Localizer.Localize('FileSystemObject_New')
                    }, {
                      img: _withCtx(() => [
                        _hoisted_15
                      ]),
                      submenu: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["context_menu_btn", {disabled: !_ctx.Can_NewFolder}]),
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.Fso_NewFolder()))
                        }, [
                          _hoisted_16,
                          _createTextVNode("  " + _toDisplayString(_ctx.Localizer.Localize('FileSystemObject_Folder')), 1)
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["context_menu_btn", {disabled: !_ctx.Can_NewProcess}]),
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.Fso_NewProcess()))
                        }, [
                          _hoisted_17,
                          _createTextVNode("  " + _toDisplayString(_ctx.Localizer.Localize('FileSystemObject_Process')), 1)
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["context_menu_btn", {disabled: !_ctx.Can_NewReportBook}]),
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.Fso_NewReportBook()))
                        }, [
                          _hoisted_18,
                          _createTextVNode("  " + _toDisplayString(_ctx.Localizer.Localize('FileSystemObject_Report_Book')), 1)
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["context_menu_btn", {disabled: !_ctx.Can_NewPowerBI}]),
                          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.Fso_NewPowerBI()))
                        }, [
                          _hoisted_19,
                          _createTextVNode("  " + _toDisplayString(_ctx.Localizer.Localize('FileSystemObject_Power_BI_Report')), 1)
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["context_menu_btn", {disabled: !_ctx.Can_NewOfficeReport}]),
                          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.Fso_NewDocxReport()))
                        }, [
                          _hoisted_20,
                          _createTextVNode("  " + _toDisplayString(_ctx.Localizer.Localize('FileSystemObject_Word_Report')), 1)
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["context_menu_btn", {disabled: !_ctx.Can_NewOfficeReport}]),
                          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.Fso_NewPptxReport()))
                        }, [
                          _hoisted_21,
                          _createTextVNode("  " + _toDisplayString(_ctx.Localizer.Localize('FileSystemObject_Powerpoint_Report')), 1)
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["context_menu_btn", {disabled: !_ctx.Can_NewXL3}]),
                          onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.Fso_NewXL3()))
                        }, [
                          _hoisted_22,
                          _createTextVNode("  " + _toDisplayString(_ctx.Localizer.Localize('FileSystemObject_XL3_Report')), 1)
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["context_menu_btn", {disabled: !_ctx.Can_NewCalcScript}]),
                          onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.Fso_NewCalcScript()))
                        }, [
                          _hoisted_23,
                          _createTextVNode("  " + _toDisplayString(_ctx.Localizer.Localize('FileSystemObject_CalcScript')), 1)
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["context_menu_btn", {disabled: !_ctx.Can_NewGeneric}]),
                          onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.Fso_NewGeneric()))
                        }, [
                          _hoisted_24,
                          _createTextVNode("  " + _toDisplayString(_ctx.Localizer.Localize('FileSystemObject_Generic_File')), 1)
                        ], 2)
                      ]),
                      _: 1
                    }, 8, ["title"]))
                  : _createCommentVNode("", true),
                _hoisted_25,
                _createElementVNode("div", {
                  class: _normalizeClass(["context_menu_btn", {disabled: !_ctx.Can_Cut}]),
                  onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.Fso_Cut()))
                }, [
                  _hoisted_26,
                  _createTextVNode("  " + _toDisplayString(_ctx.Localizer.Localize("FileSystemObject_Cut")), 1)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["context_menu_btn", {disabled: !_ctx.Can_Copy}]),
                  onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.Fso_Copy()))
                }, [
                  _hoisted_27,
                  _createTextVNode("  " + _toDisplayString(_ctx.Localizer.Localize("FileSystemObject_Copy")), 1)
                ], 2),
                (_ctx.Fso.objectType===_ctx.FileSystemType.Folder)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 6,
                      class: _normalizeClass(["context_menu_btn", {disabled: !_ctx.Can_Paste}]),
                      onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.Fso_Paste()))
                    }, [
                      _hoisted_28,
                      _createTextVNode("  " + _toDisplayString(_ctx.Localizer.Localize("FileSystemObject_Paste")), 1)
                    ], 2))
                  : _createCommentVNode("", true),
                _hoisted_29,
                (_ctx.Fso.objectType===_ctx.FileSystemType.Form
            || _ctx.Fso.objectType===_ctx.FileSystemType.ReportBook
            || _ctx.Fso.objectType===_ctx.FileSystemType.DocxReport
            || _ctx.Fso.objectType===_ctx.FileSystemType.PptxReport)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 7,
                      class: _normalizeClass(["context_menu_btn", {disabled: !_ctx.Can_Edit}]),
                      onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.Fso_Edit()))
                    }, [
                      _hoisted_30,
                      _createTextVNode("  " + _toDisplayString(_ctx.Localizer.Localize("FileSystemObject_Edit")), 1)
                    ], 2))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(["context_menu_btn", {disabled: !_ctx.Can_Rename}]),
                  onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.Fso_Rename()))
                }, [
                  _hoisted_31,
                  _createTextVNode("  " + _toDisplayString(_ctx.Localizer.Localize("FileSystemObject_Rename")), 1)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["context_menu_btn", {disabled: !_ctx.Can_Delete}]),
                  onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.OpenConfirmDelete()))
                }, [
                  _hoisted_32,
                  _createTextVNode("  " + _toDisplayString(_ctx.Localizer.Localize("FileSystemObject_Delete")), 1)
                ], 2),
                _hoisted_33,
                _createElementVNode("div", {
                  class: _normalizeClass(["context_menu_btn", {disabled: !_ctx.Can_Export}]),
                  onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.Fso_Export()))
                }, [
                  _hoisted_34,
                  _createTextVNode("  " + _toDisplayString(_ctx.Localizer.Localize("FileSystemObject_Export")), 1)
                ], 2),
                (_ctx.Fso.objectType==_ctx.FileSystemType.XL3)
                  ? (_openBlock(), _createBlock(_component_ContextMenuButton, {
                      key: 8,
                      title: _ctx.Localizer.Localize('Export As'),
                      class: _normalizeClass({disabled: !_ctx.Can_SaveAs})
                    }, {
                      img: _withCtx(() => [
                        _hoisted_35
                      ]),
                      submenu: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "context_menu_btn",
                          onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.Fso_SaveAs('pdf')))
                        }, [
                          _hoisted_36,
                          _createTextVNode("  PDF ")
                        ]),
                        _createElementVNode("div", {
                          class: "context_menu_btn",
                          onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.Fso_SaveAs('excel')))
                        }, [
                          _hoisted_37,
                          _createTextVNode("  Excel ")
                        ]),
                        _createElementVNode("div", {
                          class: "context_menu_btn",
                          onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.Fso_SaveAs('powerpoint')))
                        }, [
                          _hoisted_38,
                          _createTextVNode("  Powerpoint ")
                        ])
                      ]),
                      _: 1
                    }, 8, ["title", "class"]))
                  : _createCommentVNode("", true),
                (_ctx.Fso.objectType===_ctx.FileSystemType.Folder)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 9,
                      class: _normalizeClass(["context_menu_btn", {disabled: !_ctx.Can_Import}]),
                      onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.Fso_Import()))
                    }, [
                      _hoisted_39,
                      _createTextVNode("  " + _toDisplayString(_ctx.Localizer.Localize("FileSystemObject_Import")), 1)
                    ], 2))
                  : _createCommentVNode("", true),
                _hoisted_40,
                (_ctx.Fso.objectType===_ctx.FileSystemType.Folder)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 10,
                      class: _normalizeClass(["context_menu_btn", {disabled: !_ctx.Can_Security}]),
                      onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.Fso_Security()))
                    }, [
                      _hoisted_41,
                      _createTextVNode("  " + _toDisplayString(_ctx.Localizer.Localize("FileSystemObject_Security")), 1)
                    ], 2))
                  : _createCommentVNode("", true),
                (_ctx.Can_FixProcessIds)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 11,
                      class: "context_menu_btn",
                      onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.FixProcessIds()))
                    }, [
                      _hoisted_42,
                      _createTextVNode("  Fix Process Ids ")
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.Fso.name==='/')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 12,
                      class: "context_menu_btn",
                      onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.Refresh()))
                    }, [
                      _hoisted_43,
                      _createTextVNode("  " + _toDisplayString(_ctx.Localizer.Localize("Refresh")), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["TriggerEvent"]))
          : _createCommentVNode("", true),
        (_ctx.ShowConfirmDelete)
          ? (_openBlock(), _createBlock(_component_Confirm, {
              key: 1,
              onClose: _ctx.CloseConfirmDelete
            }, {
              icon: _withCtx(() => [
                _hoisted_44
              ]),
              body: _withCtx(() => [
                _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.Localizer.Localize("File_Confirm_Delete")), 1)
              ]),
              footer: _withCtx(() => [
                _createVNode(_component_CommonButton, {
                  type: _ctx.ButtonType.Default,
                  text: _ctx.Localizer.Localize('Cancel_PascalCase'),
                  onClick: _ctx.CloseConfirmDelete
                }, null, 8, ["type", "text", "onClick"]),
                _createVNode(_component_CommonButton, {
                  type: _ctx.ButtonType.Primary,
                  text: _ctx.Localizer.Localize('Delete_PascalCase'),
                  onClick: _cache[36] || (_cache[36] = ($event: any) => {_ctx.Fso_Delete(); _ctx.CloseConfirmDelete()})
                }, null, 8, ["type", "text"])
              ]),
              _: 1
            }, 8, ["onClose"]))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}